module.exports = __webpack_public_path__ + "images/social-icons-d94ffc.svg";